var g = (f => (f[f.Left = 0] = "Left", f[f.Right = 2] = "Right", f))(g || {});
export { g as MouseButton };